import {useMMKVObject} from 'react-native-mmkv';
import {StreakStatus} from '../core/streak';
import {streakStatusKey} from '../storage';

export function useStreakStatus() {
  const [streakStatus] = useMMKVObject<StreakStatus>(streakStatusKey);
  return streakStatus;
}
